import * as Init from '../init.js';
import {
    CLAPI
} from '../clchart/cl.api.js'
import * as DATAS from '../datas/transdata.js'
import * as CHOLD from './changehold.res.js'
import * as COMMON from './common.res.js'

function setCodeCtrl(curChart, inData, region) {
    const chartName = 'CodeCtrl'
    const chart = curChart.getChart(chartName)

    COMMON.initHeadCtrl('持仓代码')

    for (let index = 0; index < inData['codes'].length; index++) {
        COMMON.incrHeadCtrl(inData['codes'][index])
    }

    const curRect = CLAPI.getChartRect(region)
    const curCfg = {
        layout: {
            title: {
                pixel: 12, // 字体大小
                height: 18, // 最大高度
                spaceX: 10, // X方向留空
                spaceY: 2, // Y方向留空
            }
        },
        config: COMMON.CHART_HEAD_INFOS,
        rectMain: curRect
    }

    const codeindex = DATAS.getArrayIndex(Init.getUserInfo(inData.modulename, 'codeindex', 0), inData['codes'].length)
    curCfg.config.selectIndex = codeindex;
    
    chart.createChart(chartName, 'system.ctrls', curCfg, function (result) {
        // 这里应该返回交互信息 比如按钮按下 光标位置等
        if (result.event === 'btndown') {
            // console.log(chartName, result)
            Init.setUserInfo(inData.modulename, 'codeindex', result.selectIndex)
            onLoadFactor(inData)
        }
    })
}

function setFactorCtrl(curChart, inData, region) {
    const chartName = 'FactorCtrl'
    const chart = curChart.getChart(chartName)

    COMMON.initDateCtrl('因子列表')
    
    for (let index = 0; index < inData['factors'].datas.length; index++) {
        const cinfo = CLAPI.getData(inData['factors'], 'fname', index)
        const vrate = CLAPI.getData(inData['factors'], 'gain_rate', index) / 100.0
        COMMON.incrDateCtrlLeft(index, cinfo, vrate)
    }

    const curRect = CLAPI.getChartRect(region)
    const curCfg = {
        layout: {
            offset: { // 图形的偏移位置（不包括标题等），margin为整个图形区，offset仅仅是图形
                left: 1,
                top: 0,
                right: 0,
                bottom: 1,
            },
            title: {
                pixel: 12, // 字体大小
                height: 18, // 最大高度
                spaceX: 10, // X方向留空
                spaceY: 4, // Y方向留空
            }
        },
        config: COMMON.CHART_LEFT_DATES,
        rectMain: curRect

    }
    let factorindex = DATAS.getArrayIndex(Init.getUserInfo(inData.modulename, 'factorindex', 0), inData['factors'].datas.length)
    curCfg.config.selectIndex = factorindex
    // console.log(leftLayoutCfg.config.selectIndex);
    // const leftchart = 
    chart.createChart(chartName, 'system.ctrls', curCfg, function (result) {
        // 这里应该返回交互信息 比如按钮按下 光标位置等
        if (result.event === 'btndown') {
            console.log(chartName, result)
            factorindex = Init.getUserInfo(inData.modulename, 'factorindex', 0)
            if (factorindex !== result.selectIndex) {
                Init.setUserInfo(inData.modulename, 'factorindex', result.selectIndex)
                onLoadData(inData, false)
            }
        }
    })
}

function setAnalyHold(curChart, inData, region) {
    const chartName = 'AnalyHold'
    const chart = curChart.getChart(chartName)

    const mainRect = CLAPI.getChartRect(region, 1, 3, 0, 0)

    // 设置界面信息和绑定数据
    const mainLayoutCfg = {
        config: CLAPI.Utils.mergeObjectOfDeep({
                zoomInfo: {
                    index: 6,
                },
                title: {
                    label: "持仓超额",
                },
                lines: CHOLD.analy_sydb_lines,
            },
            CLAPI.ChartRes.CHART_ZOOM_HEAD),
        rectMain: mainRect
    }
    console.log(mainLayoutCfg);
    // 其他为辅助数据 实际运算时
    const mainchart = chart.createChart('user.main', 'system.chart', mainLayoutCfg, function (result) {
        // 这里应该返回交互信息 比如按钮按下 光标位置等
        // console.log('main', result)
    })
    chart.bindData(mainchart, chartName)

    const holdLoyoutCfg = {
        config: CLAPI.Utils.mergeObjectOfDeep({
                title: {
                    label: "因子持仓",
                },
                axisY: {
                    left: {
                        format: 'float'
                    },
                    right: {
                        format: 'float'
                    }
                },
                lines: CHOLD.analy_yzcc_lines,
            },
            CLAPI.ChartRes.CHART_ZOOM_MIDDLE),
        rectMain: CLAPI.getChartRect(region, 1, 3, 0, 1)
    }
    const holdchart = chart.createChart('user.hold', 'system.chart', holdLoyoutCfg, function (result) {
        // console.log('hold', result)
    })
    chart.bindData(holdchart, chartName)

    const analyLayoutCfg = {
        config: CLAPI.Utils.mergeObjectOfDeep({

                title: {
                    label: "资产变动",
                },
                lines: CHOLD.analy_zcfx_lines,
            },
            CLAPI.ChartRes.CHART_ZOOM_FOOT),
        rectMain: CLAPI.getChartRect(region, 1, 3, 0, 2)
    }
    const analychart = chart.createChart('user.analy', 'system.chart', analyLayoutCfg, function (result) {
        // console.log('analy', result)
    })
    chart.bindData(analychart, chartName)

}
function readyData(curChart, inData) {
    const chartName = 'AnalyHold'
    const chart = curChart.getChart(chartName)

    const axisXinfo = DATAS.extractField(inData['vdates'], 'curr_date')
    // 设置坐标显示信息
    // console.log(axisXinfo);
    chart.setAxisXinfo(axisXinfo)

    let vdatas = CHOLD.VdatesToAnaly(inData['vdates'], inData['factor'])
    chart.setData(chartName, vdatas)
    console.log(vdatas);

}
// 画日线
function drawAnalyHold(inData, isfirst) {

    console.log('Draw ====> Analy Line')
    // console.log(JSON.stringify(inData));
    console.log(inData);

    const curChart = Init.getSysChart()
    if (isfirst) {

        // 设置为单一窗口 并返回第一个窗口
        curChart.initChart(['AnalyHold', 'CodeCtrl', 'FactorCtrl'])
    
        const canvas = Init.canvas
        
        const ctrlWidth = CHOLD.FWIDTH * Init.scale
        const clsHeight = 25 * Init.scale
    
        // 设置顶部窗口
        setCodeCtrl(curChart, inData, {
            style: 'sidebar',
            top: 0,
            left: 0,
            width: canvas.width,
            height: clsHeight,
        })
        // 设置左部窗口
        setFactorCtrl(curChart, inData, {
            style: 'sidebar',
            top: clsHeight,
            left: 0,
            width: ctrlWidth - Init.scale,
            height: canvas.height - clsHeight,
        })
        // 设置第一个窗口
        setAnalyHold(curChart, inData, {
            style:  'splitly',
            top:    clsHeight,
            left:   ctrlWidth,
            width:  canvas.width - ctrlWidth,
            height: canvas.height - clsHeight,
        })
    }

    readyData(curChart, inData)

    curChart.onPaint()
}

export function onLoadData(inData, isfirst) {

    const codeindex = DATAS.getArrayIndex(Init.getUserInfo(inData.modulename, 'codeindex', 0), inData['codes'].length)
    const currcode = inData['codes'][codeindex]

    const factorindex = DATAS.getArrayIndex(Init.getUserInfo(inData.modulename, 'factorindex', 0), inData['factors'].datas.length)
    const currfactor = CLAPI.getData(inData['factors'], 'fname', factorindex) 

    Init.sendCommand({
            cmds: {
                "vdates": {
                    "cmd": "get",
                    "subject": "vdate",
                    "service": inData.modulepath + '/' + inData.modulename + '/verify/' + currcode + '/' + currfactor + '/',
                    "info": {
                        "offset": 0
                    }
                },
            }
        },
        function reply(datas) {
            if (Init.checkDatas(datas)) {
                inData['vdates'] = datas['vdates']
                drawAnalyHold(inData, isfirst)
            }
        });
}

export function onLoadFactor(inData) {
    
    const codeindex = DATAS.getArrayIndex(Init.getUserInfo(inData.modulename, 'codeindex', 0), inData['codes'].length)
    const currcode = inData['codes'][codeindex]
    Init.sendCommand({
            // cmds: {
            //     "factors": {
            //         "cmd": "paths",
            //         "service": inData.modulepath + '/' + inData.modulename + '/verify/' + currcode + '/'
            //     }
            // }
            cmds: {
                "factors": {
                    "cmd": "get",
                    "subject": "summary",
                    "service": inData.modulepath + '/' + inData.modulename + '/verify/' + currcode + '/',
                    "info": {
                        "offset": 0
                    }
                }
            }
        },
        function reply(datas) {
            if (Init.checkDatas(datas)) {
                // inData['factors'] = []
                // for (let index = 0; index < datas['factors'].datas.length; index++) {
                //     inData['factors'].push(CLAPI.getData(datas['factors'], 'pathname', index))
                // }
                // inData['factors'].sort((a,b) => b.localeCompare(a))
                inData['factors'] = datas['factors']
                onLoadData(inData, true)
            }
        });
}

export function onLoad(argvs) {
    let inData = {}
    inData.modulename = argvs.modulename ?? 'wi_vf9'
    inData.modulepath = argvs.modulepath ?? 'factors'

    // inData['workers'] = ['daynow', 'dayago', 'femny']
    
    Init.sendCommand({
            cmds: {
                "codes": {
                    "cmd": "paths",
                    "service": inData.modulepath + '/' + inData.modulename + '/verify/'
                }
            }
        },
        function reply(datas) {
            if (Init.checkDatas(datas)) {
                inData['codes'] = []
                for (let index = 0; index < datas['codes'].datas.length; index++) {
                    inData['codes'].push(CLAPI.getData(datas['codes'], 'pathname', index))
                }
                onLoadFactor(inData)
            }
        });
}
// 注册方法到参数表